import dataGrid from './components/data-grid.vue';
import { ensureCustomQueryRoutes, openCustomQuery } from './custom-query/routes';
import { ROUTE_NAMES, ROUTE_PATHS, setStore } from './custom-query/runtime';

export { dataGrid as sDataGrid };

// 暴露路由注册函数，供宿主项目在 router 初始化时手动注册自定义查询路由
// 用法：import { registerCustomQueryRoutes } from 'sd-data-grid'; registerCustomQueryRoutes(router);
export { ensureCustomQueryRoutes as registerCustomQueryRoutes };

// 暴露打开自定义查询页面的函数，供宿主项目直接调用
export { openCustomQuery };

// 暴露路由名/路径常量，供宿主项目在路由配置中引用
export { ROUTE_NAMES, ROUTE_PATHS };

// 暴露 store 注入函数（real-api 需要宿主 store 来发请求）
export { setStore as setCustomQueryStore };


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/index.js
// module id = 51
// module chunks = 0